import { AwsUi } from '../../../../core/runtime/src';
import LegacyClassBuilder from '../../../../core/utils/src/class-builders/legacy';
import { Checkbox } from '../../../checkbox/src';
import { findParentComponent, getPreferencesController, renderSafely } from '../utility';
export var TableWrapLines = AwsUi.__addComponent('awsui-table-wrap-lines', {
    releaseStatus: 'stable',
    properties: {
        // Displayed below the checkbox on large screens. Hidden on small screens.
        description: {
            type: 'string'
        },
        // Used as label for the checkbox that allows to select the option.
        label: {
            type: 'string'
        },
        __wrapLines: {
            defaultValue: true,
            type: 'boolean'
        }
    },
    callbacks: {
        attached: function () {
            var _this = this;
            this.__parentComponent = findParentComponent(this.node, ['awsui-table']);
            this.__parentComponent.__controller.wrapLinesSelector = this;
            this.__preferencesController = getPreferencesController(this.node);
            this.__wrapLines = this.__parentComponent.__controller.getWrapLines();
            this.__preferencesListener = {
                onConfirm: function () { return _this.__parentComponent.__controller.setWrapLines(_this.__wrapLines, true); },
                onCancel: function () {
                    _this.__wrapLines = _this.__parentComponent.__controller.getWrapLines();
                    _this.__update();
                }
            };
            this.__preferencesController.addListener(this.__preferencesListener);
        },
        detached: function () {
            if (this.__preferencesController) {
                this.__parentComponent.__controller.wrapLinesSelector = null;
                this.__preferencesController.removeListener(this.__preferencesListener);
            }
        }
    },
    render: renderSafely(function (m, h) {
        var _this = this;
        var getComponentClassName = function (suffix) {
            return new LegacyClassBuilder(_this).addComponentClass(suffix).toClassName();
        };
        var changeHandler = function () {
            _this.__wrapLines = !_this.__wrapLines;
        };
        return (AwsUi.__createElement(Checkbox, { className: getComponentClassName('checkbox'), checked: this.__wrapLines, change: changeHandler, label: this.label, description: this.description }));
    })
});
//# sourceMappingURL=index.js.map